import { PendoEventBase } from './pendo-base';

export class PendoEventFollowUpMarkedAsCompleted implements PendoEventBase {
    public readonly name = 'candidates.followup.complete';
    constructor(
        public readonly metadata: {
            id: number;
            date: string;
            priority: number;
        }
    ) { }
}

export class PendoEventFollowUpAdded implements PendoEventBase {
    public readonly name = 'candidates.followup.add';
    constructor(
        public readonly metadata: {
            id: number;
            date: string;
            priority: number;
        }
    ) { }
}

export class PendoEventStafferClickedAlternativeShiftIcon implements PendoEventBase {
    public readonly name = 'alternative.shifts.click.icon';
    constructor(
        public readonly metadata: {
            canceledShiftId: number;
        }
    ) { }
}

export class PendoEventStafferScheduleAlternativeShift implements PendoEventBase {
    public readonly name = 'alternative.shifts.schedule';
    constructor(
        public readonly metadata: {
            canceledShiftId: number;
            clinicianId: number;
            newlyBookedShiftId: number;
        }
    ) { }
}

export class PendoEventStafferCancelNewlyBookedByHospital implements PendoEventBase {
    public readonly name = 'alternative.shifts.cancel.newly.booked';
    constructor(
        public readonly metadata: {
            newlyBookedShiftId: number;            
        }
    ) { }
}

export type PendoEvent = PendoEventBase | PendoEventFollowUpMarkedAsCompleted | PendoEventFollowUpAdded | PendoEventStafferCancelNewlyBookedByHospital | PendoEventStafferScheduleAlternativeShift | PendoEventStafferClickedAlternativeShiftIcon;